import { formatNumber } from "sipli-fleet-core/utils/formatNumber";
import { useTranslation } from "react-i18next";
import { ARROW_DOWN_ICON } from "src/assets/svgs";
import { cn } from "../../../../../../sipli-fleet-core/utils/cn";

interface MappingCardHeaderProps {
  title: string;
  count?: number;
  open: boolean;
  onToggle: () => void;
}

const MappingCardHeader = ({ title, count, open, onToggle }: MappingCardHeaderProps) => {
  const { i18n } = useTranslation();
  return (
  <div
    className="flex items-center justify-between border-b border-gray5 pr-4 py-1.5 cursor-pointer"
    onClick={onToggle}
  >
    <div className="flex items-center gap-[10px]">
      <span className="!text-[17.72px] !font-bold !leading-[28px] !text-black">{title}</span>
      {count !== undefined && (
        <span className="flex h-[22px] items-center justify-center rounded-[24px] bg-primary px-[12px] text-[14px] font-semibold leading-[18px] text-white">
          {formatNumber(count, i18n.language)}
        </span>
      )}
    </div>
    <img
      src={ARROW_DOWN_ICON}
      alt="Arrow Down"
      className={cn("cursor-pointer", {
        "-rotate-90": !open,
      })}
    />
  </div>
  );
};

export default MappingCardHeader;
